import { createSlice } from "@reduxjs/toolkit";
import { any } from "prop-types";
import Gallery from "../../models/gallery.model";
import pageMeta from "../../models/pagemeta.model";

export interface GalleryState {
  galleries:Array<Gallery>|undefined,
  loading:boolean,
  error:any,
  meta:pageMeta | undefined,

  videos:Array<Gallery>|undefined,
  loadingVideo:boolean,
  metaVideo:pageMeta | undefined,
  errorVideo:any
}


const initialState:GalleryState = {
  galleries:undefined,
  error:any,
  loading:false,
  meta:undefined,

  videos:undefined,
  loadingVideo:false,
  metaVideo:undefined,
  errorVideo:undefined,
} 


const gallerySlice = createSlice({
  name:'gallery',
  initialState:initialState,
  reducers:{

    fetchGalleriesRequest(state){
      state.loading = true;
    },

    fetchGalleriesSuccess(state,actions){
      state.loading = false;
      state.galleries = actions.payload.galleries;
      state.meta = actions.payload.meta;
    },


    fetchGalleriesFail(state,actions){
      state.loading = false;
      state.error = actions.payload;
    },


    // video
    fetchVideosRequest(state){
      state.loadingVideo = true;
    },

    fetchVideosSuccess(state,actions){
      state.loadingVideo = false;
      state.videos = actions.payload.videos;
      state.metaVideo = actions.payload.meta;
    },


    fetchVideosFail(state,actions){
      state.loadingVideo = false;
      state.errorVideo = actions.payload;
    },

  }
});

export const {
  fetchGalleriesRequest,
  fetchGalleriesSuccess,
  fetchGalleriesFail,


  //video
  fetchVideosFail,
  fetchVideosRequest,
  fetchVideosSuccess,
  
} = gallerySlice.actions;

export default gallerySlice.reducer;